import { BulletList } from '#/components/icons/BulletList';
import { Bold } from './Bold';
import { Caret } from './Caret';
import { Check } from './Check';
import { Cleaning } from './Cleaning';
import { CreditCard } from './CreditCard';
import { Cross } from './Cross';
import { Document } from './Document';
import { DocumentThin } from './DocumentThin';
import { Drag } from './Drag';
import { Email } from './Email';
import { Image } from './Image';
import { Info } from './Info';
import { Italic } from './Italic';
import { Key } from './Key';
import { Laundry } from './Laundry';
import { Link } from './Link';
import { Maintenance } from './Maintenance';
import { NumberList } from './NumberList';
import { Pencil } from './Pencil';
import { Plus } from './Plus';
import { Product } from './Product';
import { Profile } from './Profile';
import { Sign } from './Sign';
import { Staff } from './Staff';
import { Star } from './Star';
import { TinyArrow } from './TinyArrow';
import { Underline } from './Underline';
import { Welcome } from './Welcome';
import { Zazume } from './Zazume';

export * from './Caret';
export * from './Check';
export * from './Cleaning';
export * from './Collapse';
export * from './Cross';
export * from './Drag';
export * from './Document';
export * from './DocumentThin';
export * from './Ellipse';
export * from './Email';
export * from './Info';
export * from './Key';
export * from './Laundry';
export * from './Link';
export * from './Link';
export * from './Maintenance';
export * from './NumberList';
export * from './Pencil';
export * from './Plus';
export * from './Product';
export * from './Profile';
export * from './RightArrow';
export * from './Sign';
export * from './Staff';
export * from './Star';
export * from './Tenants';
export * from './TinyArrow';
export * from './Welcome';
export * from './Zazume';

/**
 * @deprecated use zzm-base
 */
export interface IconProps {
  color?: string;
  size?: number; //TODO: update type to IconSize when all icons are updated
  onClick?: () => void;
  cursor?: string;
}

/**
 * @deprecated use zzm-base
 */
export const Icons = <const>[
  'bold', 'bulletList',
  'caret', 'check', 'cleaning', 'creditCard', 'cross',
  'document', 'documentThin', 'drag',
  'email',
  'image', 'info', 'internet', 'italic',
  'key',
  'laundry', 'link',
  'maintenance',
  'numberList',
  'pencil', 'plus', 'product', 'profile',
  'star', 'sign', 'staff',
  'tinyArrow',
  'underline',
  'welcome',
  'zazume'
];
/**
 * @deprecated use zzm-base
 */
export type IconType = typeof Icons[number];

/**
 * @deprecated use zzm-base
 */
type IconComponent = {
  [key in IconType]: any;
}

/**
 * @deprecated use zzm-base
 */
const IconsComponent: IconComponent = {
  bold: Bold,
  bulletList: BulletList,
  caret: Caret,
  check: Check,
  cleaning: Cleaning,
  creditCard: CreditCard,
  cross: Cross,
  document: Document,
  documentThin: DocumentThin,
  drag: Drag,
  email: Email,
  image: Image,
  info: Info,
  internet: Link,
  italic: Italic,
  key: Key,
  laundry: Laundry,
  link: Link,
  maintenance: Maintenance,
  numberList: NumberList,
  pencil: Pencil,
  plus: Plus,
  product: Product,
  profile: Profile,
  sign: Sign,
  staff: Staff,
  star: Star,
  tinyArrow: TinyArrow,
  underline: Underline,
  welcome: Welcome,
  zazume: Zazume
};

/**
 * @deprecated use zzm-base
 * @param name
 */
export const getIcon = (name: IconType) =>
  IconsComponent[name];

/**
 * @deprecated use zzm-base
 */
const IconSizes = <const>[16, 20, 24, 32, 40];
/**
 * @deprecated use zzm-base
 */
export type IconSize = typeof IconSizes[number];

// TODO remove the | number ASAP
/**
 * @deprecated use zzm-base
 * @param size
 */
export const getStrokeWidth = (size: IconSize | number) => {
  switch (size) {
    case 16:
      return 2;
    case 20:
      return 1.68;
    case 24:
      return 1.5;
    case 32:
      return 1.2;
    case 40:
      return 1.02;
  }
};
